import { autoserialize } from "cerialize";
import TUKGrowthMetricItem from "./TUKGrowthMetricItem";
import EntityAware from "../EntityAware";

export default class TUKGrowthMetrics implements EntityAware {
    @autoserialize
    public income: TUKGrowthMetricItem = new TUKGrowthMetricItem();

    @autoserialize
    public expense: TUKGrowthMetricItem = new TUKGrowthMetricItem();
}
